/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const AutomapOptions = core.serialization.object({
    accuracy: core.serialization.string(),
    defaultTargetSheet: core.serialization.string(),
    matchFilename: core.serialization.string(),
});
